import { render } from "./product.vue?vue&type=template&id=19ba5dca&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"

import "./product.vue?vue&type=style&index=0&id=19ba5dca&lang=less&scoped=true"

import exportComponent from "/Users/shixiaolong/Desktop/code/海玛_EN/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ba5dca"]])

export default __exports__